"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ComponentContainer = void 0;
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _styledComponentThemes = _interopRequireDefault(require("../../packages/styled-component-themes"));
var _Container = _interopRequireDefault(require("./Container"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var themes = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const ComponentContainer = function (props) {
  var _componentDesign$back, _componentDesign$back2, _componentDesign$tagI;
  const {
    theme,
    heading,
    headingColor,
    subHeading,
    subHeadingColor,
    componentDesign,
    className,
    children,
    id
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.ComponentContainer, {
    $theme: theme,
    $backgroundColor: (componentDesign === null || componentDesign === void 0 ? void 0 : componentDesign.backgroundColor) || "",
    $backgroundOpacity: (_componentDesign$back = componentDesign === null || componentDesign === void 0 ? void 0 : componentDesign.backgroundOpacity) !== null && _componentDesign$back !== void 0 ? _componentDesign$back : 1,
    $backgroundImage: componentDesign === null || componentDesign === void 0 ? void 0 : (_componentDesign$back2 = componentDesign.backgroundMedia) === null || _componentDesign$back2 === void 0 ? void 0 : _componentDesign$back2.image,
    className: className,
    as: _Container.default,
    id: (_componentDesign$tagI = componentDesign === null || componentDesign === void 0 ? void 0 : componentDesign.tagId) !== null && _componentDesign$tagI !== void 0 ? _componentDesign$tagI : id,
    "data-testid": "ComponentContainer",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Wrapper, {
      className: "component-container-wrapper",
      children: [(heading || subHeading) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.HeadingsContainer, {
        children: [heading && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Heading, {
          $headingColor: headingColor,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: heading
          })
        }), subHeading && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SubHeading, {
          $subHeadingColor: subHeadingColor,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: subHeading
          })
        })]
      }), children]
    })
  });
};
exports.ComponentContainer = ComponentContainer;
var _default = exports.default = (0, _styledComponentThemes.default)(ComponentContainer, themes);